<template>
  <div class="card">
    <div class="card-header">
      <h4 class="mb-0">{{ $t("reconciliation.title") }}</h4>
    </div>
    <div class="card-body">
      <div class="filters-section decaissement-filters-stacked">
        <div class="filters-header decaissement-filters-header">
          <h4>
            <a-icon type="filter" class="filter-icon" />
            {{ $t("all.filtresEtRecherche") }}
          </h4>
          <div class="action-button-group">
            <a-button class="action-button" @click="resetFilters">
              {{ $t("factures.resetFilters") }}
            </a-button>
            <a-button
              type="primary"
              class="action-button"
              @click="applyFilters"
            >
              {{ $t("action.search") }}
            </a-button>
          </div>
        </div>
        <a-row :gutter="[16, 16]" type="flex" class="decaissement-filters-row">
          <a-col :xs="24" :sm="8" :md="8" :lg="8" class="filter-col">
            <div class="filter-item filter-item-stack">
              <label class="filter-label">
                <a-icon type="search" class="action-icon" />
                {{ $t("paiementHistory.searchReceipt") }}
              </label>
              <a-input
                v-model="filters.search"
                allow-clear
                class="filter-control"
                :placeholder="$t('paiementHistory.searchReceipt')"
                @pressEnter="applyFilters"
              >
                <a-icon slot="prefix" type="search" />
              </a-input>
            </div>
          </a-col>
          <a-col :xs="24" :sm="8" :md="8" :lg="8" class="filter-col">
            <div class="filter-item filter-item-stack">
              <label class="filter-label">
                <a-icon type="swap" class="action-icon" />
                {{ $t("paiementHistory.paymentMode") }}
              </label>
              <a-select
                v-model="filters.paymentMode"
                allow-clear
                class="filter-control"
                :placeholder="$t('all.tpiAll')"
                @change="applyFilters"
              >
                <a-select-option value="immediate">{{
                  $t("paiementHistory.immediate")
                }}</a-select-option>
                <a-select-option value="scheduled">{{
                  $t("paiementHistory.scheduled")
                }}</a-select-option>
              </a-select>
            </div>
          </a-col>
          <a-col :xs="24" :sm="8" :md="8" :lg="8" class="filter-col">
            <div class="filter-item filter-item-stack">
              <label class="filter-label">
                <a-icon type="credit-card" class="action-icon" />
                {{ $t("paiementHistory.method") }}
              </label>
              <a-select
                v-model="filters.method"
                allow-clear
                class="filter-control"
                :placeholder="$t('all.tpiAll')"
                @change="applyFilters"
              >
                <a-select-option value="cash">{{
                  $t("decaissement.paymentMethod.cash")
                }}</a-select-option>
                <a-select-option value="cheque">{{
                  $t("decaissement.paymentMethod.cheque")
                }}</a-select-option>
                <a-select-option value="virement">{{
                  $t("decaissement.paymentMethod.virement")
                }}</a-select-option>
                <a-select-option value="traite">{{
                  $t("decaissement.paymentMethod.traite")
                }}</a-select-option>
                <a-select-option value="tpe">{{
                  $t("decaissement.paymentMethod.tpe")
                }}</a-select-option>
                <a-select-option value="prelevement">{{
                  $t("decaissement.paymentMethod.prelevement")
                }}</a-select-option>
              </a-select>
            </div>
          </a-col>
        </a-row>
        <a-row :gutter="[16, 16]" type="flex" class="decaissement-filters-row">
          <a-col :xs="24" :sm="8" :md="8" :lg="8" class="filter-col">
            <div class="filter-item filter-item-stack">
              <label class="filter-label">
                <a-icon type="check-circle" class="action-icon" />
                {{ $t("reconciliation.filterValidationStatus") }}
              </label>
              <a-select
                v-model="filters.validationStatus"
                class="filter-control"
                @change="applyFilters"
              >
                <a-select-option value="pending_validation">{{
                  $t("reconciliation.filterPendingValidation")
                }}</a-select-option>
                <a-select-option value="validated">{{
                  $t("reconciliation.filterValidatedOnly")
                }}</a-select-option>
                <a-select-option value="rejected">{{
                  $t("reconciliation.filterRejectedOnly")
                }}</a-select-option>
                <a-select-option value="all">{{
                  $t("reconciliation.filterAllPayments")
                }}</a-select-option>
              </a-select>
            </div>
          </a-col>
          <a-col :xs="24" :sm="8" :md="8" :lg="8" class="filter-col">
            <div class="filter-item filter-item-stack">
              <label class="filter-label">
                <a-icon type="calendar" class="action-icon" />
                {{ $t("paiementHistory.dateRange") }}
              </label>
              <a-range-picker
                v-model="filters.dateRange"
                class="filter-control date-range-filter"
                format="DD/MM/YYYY"
                style="width: 100%"
                @change="applyFilters"
              />
            </div>
          </a-col>
          <a-col :xs="24" :sm="8" :md="8" :lg="8" class="filter-col">
            <div class="filter-item filter-item-stack">
              <label class="filter-label">
                <a-icon type="user" class="action-icon" />
                {{ $t("reconciliation.createdBy") }}
              </label>
              <a-select
                v-model="filters.createdBy"
                allow-clear
                show-search
                option-filter-prop="children"
                class="filter-control"
                :placeholder="$t('all.tpiAll')"
                :loading="creatorOptionsLoading"
                @change="applyFilters"
              >
                <a-select-option
                  v-for="u in creatorUsernames"
                  :key="u"
                  :value="u"
                >
                  {{ u }}
                </a-select-option>
              </a-select>
            </div>
          </a-col>
        </a-row>
      </div>

      <div class="legend-bar mb-3">
        <div class="legend-bar-inner">
          <span class="legend-item"
            ><a-icon type="wallet" class="legend-cash" />
            {{ $t("decaissement.paymentMethod.cash") }}</span
          >
          <span class="legend-item"
            ><a-icon type="credit-card" class="legend-cheque" />
            {{ $t("decaissement.paymentMethod.cheque") }}</span
          >
          <span class="legend-item"
            ><a-icon type="bank" class="legend-virement" />
            {{ $t("decaissement.paymentMethod.virement") }}</span
          >
          <span class="legend-item"
            ><a-icon type="file-protect" class="legend-traite" />
            {{ $t("decaissement.paymentMethod.traite") }}</span
          >
          <span class="legend-item"
            ><a-icon type="tablet" class="legend-tpe" />
            {{ $t("decaissement.paymentMethod.tpe") }}</span
          >
          <span class="legend-item"
            ><a-icon type="sync" class="legend-prelevement" />
            {{ $t("decaissement.paymentMethod.prelevement") }}</span
          >
          <span class="legend-item"
            ><a-icon type="swap" class="legend-inverse" />
            {{ $t("reconciliation.paymentTypeInverse") }}</span
          >
        </div>
      </div>
      <div class="table-container">
        <a-table
          row-key="_id"
          :loading="loading"
          :columns="columns"
          :data-source="payments"
          :pagination="tablePagination"
          :scroll="{ x: 'max-content' }"
          :row-class-name="reconciliationRowClassName"
          @change="onTableChange"
        >
          <template slot="paymentType" slot-scope="text, record">
            <a-tag
              v-if="record._isInversePayment"
              color="orange"
              class="payment-type-tag"
            >
              <a-icon type="swap" class="mr-1" />
              {{ $t("reconciliation.paymentTypeInverse") }}
            </a-tag>
            <a-tag v-else color="blue" class="payment-type-tag">
              <a-icon type="arrow-right" class="mr-1" />
              {{ $t("reconciliation.paymentTypeNormal") }}
            </a-tag>
          </template>
          <template slot="caisseDebit" slot-scope="text, record">
            <template v-if="record._caisseDebitPending">
              <a-tag color="orange">
                {{ $t("reconciliation.caisseDebitPending") }}
              </a-tag>
            </template>
            <template v-else>
              <a-tag color="green">
                {{ $t("reconciliation.caisseDebitAlreadyApplied") }}
              </a-tag>
            </template>
          </template>
          <template slot="invoiceRef" slot-scope="text, record">
            <span class="invoice-cell">{{ text || "—" }}</span>
            <div
              v-if="record._expenseLabel && record._expenseLabel !== text"
              class="text-muted small"
            >
              {{ record._expenseLabel }}
            </div>
          </template>
          <template slot="benType" slot-scope="text">
            <span v-if="text === 'provider'" class="ben-type"
              ><a-icon type="shop" class="legend-provider" />
              {{ $t("factures.beneficiaryProvider") }}</span
            >
            <span v-else-if="text === 'associate'" class="ben-type"
              ><a-icon type="team" class="legend-associate" />
              {{ $t("factures.beneficiaryAssociate") }}</span
            >
            <span v-else-if="text === 'employee'" class="ben-type"
              ><a-icon type="user" class="legend-employee" />
              {{ $t("factures.beneficiaryEmployee") }}</span
            >
            <span v-else-if="text === 'company'" class="ben-type"
              ><a-icon type="apartment" class="legend-company" />
              {{ $t("factures.beneficiaryCompany") }}</span
            >
            <span v-else-if="text === 'debiteur'" class="ben-type"
              ><a-icon type="bank" class="legend-debiteur" />
              {{ $t("factures.beneficiaryDebiteur") }}</span
            >
            <span v-else class="ben-type">—</span>
          </template>
          <template slot="beneficiary" slot-scope="text">
            <span class="client-name">{{ text || "—" }}</span>
          </template>
          <template slot="amount" slot-scope="text">
            <span class="amount-cell">{{
              text != null ? text.toFixed(3) : "—"
            }}</span>
          </template>
          <template slot="date" slot-scope="text">
            <span class="date-cell">{{ formatDate(text) }}</span>
          </template>
          <template slot="method" slot-scope="text, record">
            <span
              v-if="!record.methods || !record.methods.length"
              class="text-muted"
              >—</span
            >
            <span
              v-else-if="record.methods.length > 1"
              class="payment-method-cell payment-method-multi"
            >
              <a-icon
                v-for="m in record.methods"
                :key="m"
                :type="paymentMethodIcon(m)"
                :class="paymentMethodLegendClass(m)"
                class="mixed-icon mr-1"
              />
            </span>
            <span v-else class="payment-method-cell payment-method-single">
              <a-icon
                :type="paymentMethodIcon(record.methods[0])"
                :class="paymentMethodLegendClass(record.methods[0])"
                class="mr-1"
              />
              {{ $t("decaissement.paymentMethod." + record.methods[0]) }}
            </span>
          </template>
          <template slot="creator" slot-scope="text">
            <span class="user-cell">{{ text || "—" }}</span>
          </template>
          <template slot="validationStatus" slot-scope="text, record">
            <a-tag :color="validationStatusColor(text)">
              {{ validationStatusLabel(text) }}
            </a-tag>
            <div
              v-if="validationDecisionDate(record)"
              class="text-muted small mt-1 validation-date-cell"
            >
              {{ formatDateTime(validationDecisionDate(record)) }}
            </div>
            <div
              v-if="text === 'rejected' && record.rejectionReason"
              class="text-muted small mt-1 rejection-reason-cell"
            >
              {{ record.rejectionReason }}
            </div>
          </template>
          <template slot="action" slot-scope="text, record">
            <div class="reconciliation-actions">
              <a-tooltip :title="$t('caisse.details')">
                <a-button
                  type="default"
                  size="small"
                  icon="file-search"
                  class="reconciliation-actions__btn"
                  @click="openPaymentDetail(record)"
                />
              </a-tooltip>
              <div
                v-if="record.validationStatus === 'pending_validation'"
                class="reconciliation-actions__decision"
              >
                <a-button
                  type="primary"
                  size="small"
                  icon="check"
                  class="reconciliation-actions__btn"
                  @click="openValidateModal(record)"
                >
                  {{ $t("reconciliation.validatePayment") }}
                </a-button>
                <a-button
                  type="danger"
                  size="small"
                  icon="close"
                  class="reconciliation-actions__btn"
                  @click="openRejectModal(record)"
                >
                  {{ $t("reconciliation.rejectPayment") }}
                </a-button>
              </div>
            </div>
          </template>
        </a-table>
      </div>
      <div
        v-if="!loading && payments.length === 0"
        class="text-center text-muted py-4 empty-state"
      >
        {{ emptyStateMessage }}
      </div>
    </div>

    <a-modal
      :visible="validateModalVisible"
      :title="$t('reconciliation.validateModalTitle')"
      :confirm-loading="validating"
      :ok-text="$t('reconciliation.validatePayment')"
      :cancel-text="$t('action.annuler')"
      :width="640"
      @ok="submitValidate"
      @cancel="closeValidateModal"
      destroy-on-close
    >
      <template v-if="validateTarget">
        <a-descriptions bordered :column="1" size="small" class="mb-3">
          <a-descriptions-item
            :label="$t('reconciliation.validateModalPaymentType')"
          >
            <a-tag v-if="validateTarget._isInversePayment" color="orange">
              <a-icon type="swap" class="mr-1" />
              {{ $t("reconciliation.paymentTypeInverse") }}
            </a-tag>
            <a-tag v-else color="blue">
              {{ $t("reconciliation.paymentTypeNormal") }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('saisiePaiement.invoiceRef')">
            {{ validateTarget._invoiceRef || "—" }}
          </a-descriptions-item>
          <a-descriptions-item :label="$t('saisiePaiement.beneficiary')">
            {{ validateTarget._beneficiaryName || "—" }}
          </a-descriptions-item>
          <a-descriptions-item
            :label="$t('reconciliation.validateModalAmount')"
          >
            <span class="amount-cell">{{
              (validateTarget.totalToPay || 0).toFixed(3)
            }}</span>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('reconciliation.createdBy')">
            {{ validateTarget.createdBy || "—" }}
          </a-descriptions-item>
        </a-descriptions>

        <a-alert
          v-if="
            validateTarget._isInversePayment &&
            validateTarget._caisseDebitPending
          "
          type="warning"
          show-icon
          class="mb-3"
        >
          <template slot="message">
            {{ $t("reconciliation.validateModalInverseIntro") }}
          </template>
          <template slot="description">
            <p class="mb-2">
              {{ $t("reconciliation.validateModalInverseDebitList") }}
            </p>
            <ul class="validate-split-list mb-0">
              <li
                v-for="(line, idx) in validateTarget._splitLines || []"
                :key="idx"
              >
                <strong>{{ formatSplitLine(line) }}</strong>
              </li>
            </ul>
          </template>
        </a-alert>

        <a-alert
          v-else-if="validateTarget._isInversePayment"
          type="info"
          show-icon
          class="mb-3"
          :message="$t('reconciliation.validateModalInverseAlreadyDebited')"
        />

        <a-alert
          v-else
          type="info"
          show-icon
          :message="$t('reconciliation.validateModalNormalIntro')"
        />
      </template>
    </a-modal>

    <a-modal
      :visible="rejectModalVisible"
      :title="$t('reconciliation.rejectPayment')"
      :confirm-loading="rejecting"
      @ok="submitReject"
      @cancel="rejectModalVisible = false"
      destroy-on-close
    >
      <a-form :form="rejectForm" layout="vertical">
        <a-form-item :label="$t('reconciliation.rejectionReason')">
          <a-textarea
            v-decorator="[
              'rejectionReason',
              {
                rules: [
                  {
                    required: true,
                    message: $t('reconciliation.rejectionReasonRequired'),
                  },
                ],
              },
            ]"
            :rows="3"
          />
        </a-form-item>
      </a-form>
    </a-modal>

    <PaymentDetailDrawer
      :visible="detailDrawerVisible"
      :payment-id="detailPaymentId"
      @close="detailDrawerVisible = false"
    />
  </div>
</template>

<script>
import moment from "moment";
import {
  fetchPendingPayments,
  fetchReconciliationPendingCreators,
  validatePayment,
  rejectPayment,
} from "@/services/api/compV3/paymentEntry";
import { showApiError } from "@/utilities/showApiError";
import PaymentDetailDrawer from "@/views/compV3/decaissement/paymentHistory/PaymentDetailDrawer.vue";

export default {
  name: "ReconciliationPage",
  components: { PaymentDetailDrawer },
  beforeMount() {
    this.rejectForm = this.$form.createForm(this, { name: "rejectForm" });
  },
  data() {
    return {
      payments: [],
      loading: false,
      pagination: { current: 1, pageSize: 20, total: 0 },
      filters: {
        search: "",
        paymentMode: undefined,
        method: undefined,
        dateRange: [],
        createdBy: undefined,
        validationStatus: "pending_validation",
      },
      creatorUsernames: [],
      creatorOptionsLoading: false,
      rejectModalVisible: false,
      rejectingId: null,
      rejecting: false,
      detailDrawerVisible: false,
      detailPaymentId: null,
      validateModalVisible: false,
      validateTarget: null,
      validating: false,
    };
  },
  computed: {
    tablePagination() {
      return {
        current: this.pagination.current,
        pageSize: this.pagination.pageSize,
        total: this.pagination.total,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50"],
        showTotal: (t) => `${t}`,
      };
    },
    emptyStateMessage() {
      const vf = this.filters.validationStatus;
      if (vf === "rejected") return this.$t("reconciliation.noPaymentsRejected");
      if (vf === "validated") return this.$t("reconciliation.noPaymentsValidated");
      if (vf === "all") return this.$t("reconciliation.noPaymentsFound");
      return this.$t("reconciliation.noPaymentsPending");
    },
    columns() {
      return [
        {
          title: this.$t("saisiePaiement.invoiceRef"),
          dataIndex: "_invoiceRef",
          key: "ref",
          scopedSlots: { customRender: "invoiceRef" },
        },
        {
          title: this.$t("reconciliation.colPaymentType"),
          key: "paymentType",
          width: 130,
          scopedSlots: { customRender: "paymentType" },
        },
        {
          title: this.$t("reconciliation.colCaisseDebit"),
          key: "caisseDebit",
          width: 180,
          scopedSlots: { customRender: "caisseDebit" },
        },
        {
          title: this.$t("saisiePaiement.filterBeneficiaryType"),
          dataIndex: "_beneficiaryType",
          key: "benType",
          width: 140,
          scopedSlots: { customRender: "benType" },
        },
        {
          title: this.$t("saisiePaiement.beneficiary"),
          dataIndex: "_beneficiaryName",
          key: "ben",
          scopedSlots: { customRender: "beneficiary" },
        },
        {
          title: this.$t("saisiePaiement.amount"),
          dataIndex: "totalToPay",
          key: "amt",
          scopedSlots: { customRender: "amount" },
        },
        {
          title: this.$t("recette.datePaiement"),
          dataIndex: "paidAt",
          key: "date",
          scopedSlots: { customRender: "date" },
        },
        {
          title: this.$t("paiementHistory.method"),
          dataIndex: "methods",
          key: "method",
          width: 220,
          scopedSlots: { customRender: "method" },
        },
        {
          title: this.$t("reconciliation.createdBy"),
          dataIndex: "createdBy",
          key: "creator",
          scopedSlots: { customRender: "creator" },
        },
        {
          title: this.$t("paiementHistory.validationStatus"),
          dataIndex: "validationStatus",
          key: "validationStatus",
          width: 160,
          scopedSlots: { customRender: "validationStatus" },
        },
        {
          title: this.$t("action.actions"),
          key: "action",
          scopedSlots: { customRender: "action" },
          width: 280,
          fixed: "right",
          align: "right",
        },
      ];
    },
  },
  async created() {
    await Promise.all([this.loadCreatorOptions(), this.fetchData()]);
  },
  methods: {
    buildQueryParams() {
      const p = {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
      };
      if (this.filters.search && String(this.filters.search).trim()) {
        p.search = String(this.filters.search).trim();
      }
      if (this.filters.paymentMode) p.paymentMode = this.filters.paymentMode;
      if (this.filters.method) p.method = this.filters.method;
      if (this.filters.createdBy) p.createdBy = this.filters.createdBy;
      if (this.filters.validationStatus) {
        p.validationStatus = this.filters.validationStatus;
      }
      if (this.filters.dateRange && this.filters.dateRange.length === 2) {
        p.dateFrom = this.filters.dateRange[0].format("YYYY-MM-DD");
        p.dateTo = this.filters.dateRange[1].format("YYYY-MM-DD");
      }
      return p;
    },
    async loadCreatorOptions() {
      this.creatorOptionsLoading = true;
      try {
        const params = {};
        if (this.filters.validationStatus) {
          params.validationStatus = this.filters.validationStatus;
        }
        const res = await fetchReconciliationPendingCreators(params);
        this.creatorUsernames = res.data?.data || [];
      } catch {
        this.creatorUsernames = [];
      } finally {
        this.creatorOptionsLoading = false;
      }
    },
    applyFilters() {
      this.pagination.current = 1;
      this.loadCreatorOptions();
      this.fetchData();
    },
    resetFilters() {
      this.filters = {
        search: "",
        paymentMode: undefined,
        method: undefined,
        dateRange: [],
        createdBy: undefined,
        validationStatus: "pending_validation",
      };
      this.applyFilters();
    },
    validationStatusColor(s) {
      if (s === "validated") return "green";
      if (s === "rejected") return "red";
      return "orange";
    },
    validationStatusLabel(s) {
      const key = `paiementHistory.validationStatuses.${s}`;
      const t = this.$t(key);
      return t !== key ? t : s || "—";
    },
    reconciliationRowClassName(record, index) {
      const stripe = index % 2 === 0 ? "table-row-even" : "table-row-odd";
      if (record && record.validationStatus === "rejected") {
        return `${stripe} reconciliation-row-rejected`;
      }
      if (record && record._isInversePayment) {
        return `${stripe} reconciliation-row-inverse`;
      }
      return stripe;
    },
    formatDate(v) {
      return v ? moment(v).format("DD/MM/YYYY") : "—";
    },
    formatDateTime(v) {
      return v ? moment(v).format("DD/MM/YYYY HH:mm") : "—";
    },
    validationDecisionDate(record) {
      if (!record) return null;
      if (record.validationStatus === "validated") {
        return record.validatedAt || record.updatedAt || null;
      }
      if (record.validationStatus === "rejected") {
        return record.rejectedAt || record.updatedAt || null;
      }
      return null;
    },
    paymentMethodIcon(m) {
      const map = {
        cash: "wallet",
        cheque: "credit-card",
        virement: "bank",
        traite: "file-protect",
        prelevement: "sync",
        tpe: "tablet",
      };
      return map[m] || "dollar";
    },
    paymentMethodLegendClass(m) {
      const map = {
        cash: "legend-cash",
        cheque: "legend-cheque",
        virement: "legend-virement",
        traite: "legend-traite",
        tpe: "legend-tpe",
        prelevement: "legend-prelevement",
      };
      return map[m] || "";
    },
    async fetchData() {
      this.loading = true;
      try {
        const res = await fetchPendingPayments(this.buildQueryParams());
        const body = res.data || {};
        this.payments = body.data || [];
        this.pagination.total = body.total || 0;
        this.pagination.current = body.page || 1;
      } catch {
        this.$message.error(this.$t("warning.connectionProblem"));
      } finally {
        this.loading = false;
      }
    },
    onTableChange(pag) {
      this.pagination.current = pag.current;
      this.pagination.pageSize = pag.pageSize;
      this.fetchData();
    },
    formatSplitLine(line) {
      if (!line) return "—";
      const methodKey = `decaissement.paymentMethod.${line.method}`;
      const methodLabel = this.$t(methodKey);
      const method = methodLabel !== methodKey ? methodLabel : line.method;
      const amount = Number(line.amount || 0).toFixed(3);
      const caisse = line.caisseName || "—";
      return this.$t("reconciliation.splitLineSummary", {
        method,
        amount,
        caisse,
      });
    },
    openValidateModal(record) {
      this.validateTarget = record;
      this.validateModalVisible = true;
    },
    closeValidateModal() {
      this.validateModalVisible = false;
      this.validateTarget = null;
    },
    async submitValidate() {
      if (!this.validateTarget) return;
      this.validating = true;
      try {
        await validatePayment(this.validateTarget._id);
        this.$message.success(this.$t("reconciliation.paymentValidated"));
        this.closeValidateModal();
        await this.loadCreatorOptions();
        await this.fetchData();
      } catch (e) {
        showApiError(this, e);
      } finally {
        this.validating = false;
      }
    },
    openPaymentDetail(record) {
      this.detailPaymentId = String(record._id);
      this.detailDrawerVisible = true;
    },
    openRejectModal(record) {
      this.rejectingId = record._id;
      this.rejectModalVisible = true;
    },
    submitReject(e) {
      e.preventDefault();
      this.rejectForm.validateFields(async (err, values) => {
        if (err) return;
        this.rejecting = true;
        try {
          await rejectPayment(this.rejectingId, values.rejectionReason);
          this.$message.success(this.$t("reconciliation.paymentRejected"));
          this.rejectModalVisible = false;
          this.rejectingId = null;
          await this.loadCreatorOptions();
          await this.fetchData();
        } catch (ex) {
          showApiError(this, ex);
        } finally {
          this.rejecting = false;
        }
      });
    },
  },
};
</script>

<style scoped>
@import "~@/views/compV3/common.css";

.reconciliation-actions {
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
  gap: 0;
  white-space: nowrap;
}

.reconciliation-actions__decision {
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 8px;
  margin-left: 20px;
  padding-left: 16px;
  border-left: 1px solid #e8e8e8;
}

.reconciliation-actions__btn {
  flex-shrink: 0;
}

/* Same legend + method cell styling as Historique des paiements */
.legend-bar-inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 20px 28px;
}
.legend-bar {
  padding: 10px 14px;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 6px;
}
.legend-item {
  font-size: 12px;
  color: #595959;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}
.legend-cash {
  color: #52c41a;
}
.legend-cheque {
  color: #1890ff;
}
.legend-virement {
  color: #722ed1;
}
.legend-traite {
  color: #fa8c16;
}
.legend-tpe {
  color: #eb2f96;
}
.legend-prelevement {
  color: #13c2c2;
}
.legend-inverse {
  color: #fa8c16;
}
.legend-mixed {
  color: #8c8c8c;
}

.payment-method-cell {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px 8px;
  font-size: 13px;
}
.payment-method-mixed .mixed-label {
  font-weight: 500;
  color: #595959;
}
.payment-method-mixed .mixed-icons {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.payment-method-mixed .mixed-icon {
  font-size: 16px;
}
.payment-method-single {
  color: #262626;
}

.payment-type-tag {
  display: inline-flex;
  align-items: center;
}

.validate-split-list {
  padding-left: 18px;
}

.validate-split-list li {
  margin-bottom: 4px;
}
</style>

<style>
.reconciliation-row-inverse > td {
  background-color: #fff7e6 !important;
}

.reconciliation-row-rejected > td {
  background-color: #fff1f0 !important;
}

.rejection-reason-cell {
  max-width: 200px;
  white-space: normal;
  line-height: 1.3;
}
</style>
